/*
 * Glassy Fancy · motion helpers
 * - Reveal: elements with [data-gf-reveal] fade/slide in once when they enter the viewport.
 * - Rails: [data-gf-rail] horizontal scrollers get prev/next buttons ([data-gf-rail-prev]/[data-gf-rail-next]).
 * No dependencies. Respects prefers-reduced-motion and the theme editor.
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = Boolean(window.Shopify && window.Shopify.designMode);
  var observer = null;

  function revealAll(scope) {
    var nodes = (scope || document).querySelectorAll('[data-gf-reveal]');
    for (var i = 0; i < nodes.length; i++) nodes[i].classList.add('is-revealed');
  }

  function applyStagger(scope) {
    var groups = (scope || document).querySelectorAll('[data-gf-stagger]');
    for (var g = 0; g < groups.length; g++) {
      var items = groups[g].querySelectorAll(':scope > [data-gf-reveal]');
      for (var i = 0; i < items.length; i++) {
        items[i].style.setProperty('--gf-delay', Math.min(i, 6) * 90 + 'ms');
      }
    }
  }

  function observe(scope) {
    applyStagger(scope);

    if (!document.body.classList.contains('gf-reveal-on') || reduceMotion || inEditor || !('IntersectionObserver' in window)) {
      revealAll(scope);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) {
              entries[i].target.classList.add('is-revealed');
              observer.unobserve(entries[i].target);
            }
          }
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    var nodes = (scope || document).querySelectorAll('[data-gf-reveal]:not(.is-revealed)');
    for (var i = 0; i < nodes.length; i++) observer.observe(nodes[i]);
  }

  function setupRails(scope) {
    var rails = (scope || document).querySelectorAll('[data-gf-rail-wrap]');
    for (var r = 0; r < rails.length; r++) {
      var wrap = rails[r];
      if (wrap.dataset.gfRailReady === 'true') continue;
      wrap.dataset.gfRailReady = 'true';

      var track = wrap.querySelector('[data-gf-rail]');
      var prev = wrap.querySelector('[data-gf-rail-prev]');
      var next = wrap.querySelector('[data-gf-rail-next]');
      if (!track) continue;

      (function (track, prev, next) {
        function step() {
          var first = track.firstElementChild;
          return first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
        }
        function update() {
          var max = track.scrollWidth - track.clientWidth - 2;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max;
        }
        var behavior = reduceMotion ? 'auto' : 'smooth';
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: behavior }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: behavior }); });
        track.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      })(track, prev, next);
    }
  }

  function init(scope) {
    try {
      observe(scope);
      setupRails(scope);
    } catch (error) {
      // Never leave content hidden if something goes wrong.
      revealAll(scope);
      if (window.console) console.warn('[Glassy Fancy] motion helpers disabled:', error);
    }
  }


  // Native <dialog> helpers: [data-gf-dialog-open="id"] opens, [data-gf-dialog-close] closes.
  document.addEventListener('click', function (event) {
    var opener = event.target.closest && event.target.closest('[data-gf-dialog-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('data-gf-dialog-open'));
      if (dialog && typeof dialog.showModal === 'function') {
        event.preventDefault();
        dialog.showModal();
        dialog.__gfOpener = opener;
      }
      return;
    }
    var closer = event.target.closest && event.target.closest('[data-gf-dialog-close]');
    if (closer) {
      var parent = closer.closest('dialog');
      if (parent) parent.close();
      return;
    }
    // Click on the backdrop closes the dialog.
    if (event.target instanceof HTMLDialogElement && event.target.classList.contains('gf-dialog')) {
      var rect = event.target.getBoundingClientRect();
      var inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
      if (!inside) event.target.close();
    }
  });

  document.addEventListener('close', function (event) {
    var dialog = event.target;
    if (dialog && dialog.__gfOpener && typeof dialog.__gfOpener.focus === 'function') {
      dialog.__gfOpener.focus();
    }
  }, true);

  root.classList.add('gf-js');

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  // Theme editor: re-run when a section is added or re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
